module.exports = __webpack_public_path__ + "static/img/boa.92bd9b1d.svg";